import AddIcon from "jsx:./flaticon-uicons/add.svg";
import AngleCircleLeftIcon from "jsx:./flaticon-uicons/angle-circle-left.svg";
import AngleCircleRightIcon from "jsx:./flaticon-uicons/angle-circle-right.svg";
import AppsSortIcon from "jsx:./flaticon-uicons/apps-sort.svg";
import ArrowCircleUpIcon from "jsx:./flaticon-uicons/arrow-circle-up.svg";
import ArrowLeftIcon from "jsx:./flaticon-uicons/arrow-left.svg";
import ArrowsIcon from "jsx:./flaticon-uicons/arrows.svg";
import BioLeavesIcon from "jsx:./flaticon-uicons/bio-leaves.svg";
import BugIcon from "jsx:./flaticon-uicons/bug.svg";
import CalendarStarIcon from "jsx:./flaticon-uicons/calendar-star.svg";
import CameraViewfinderIcon from "jsx:./flaticon-uicons/camera-viewfinder.svg";
import CareerPathIcon from "jsx:./flaticon-uicons/career-path.svg";
import ChartAreaIcon from "jsx:./flaticon-uicons/chart-area.svg";
import ChartPieAltIcon from "jsx:./flaticon-uicons/chart-pie-alt.svg";
import ChartSimpleHorizontalIcon from "jsx:./flaticon-uicons/chart-simple-horizontal.svg";
import CodeMergeIcon from "jsx:./flaticon-uicons/code-merge.svg";
import CommentAltIcon from "jsx:./flaticon-uicons/comment-alt.svg";
import CommentAltCheckIcon from "jsx:./flaticon-uicons/comment-alt-check.svg";
import ConciergeBellIcon from "jsx:./flaticon-uicons/concierge-bell.svg";
import CrossIcon from "jsx:./flaticon-uicons/cross.svg";
import CursorPlusIcon from "jsx:./flaticon-uicons/cursor-plus.svg";
import DocumentIcon from "jsx:./flaticon-uicons/document.svg";
import DotCircleIcon from "jsx:./flaticon-uicons/dot-circle.svg";
import DownloadIcon from "jsx:./flaticon-uicons/download.svg";
import DrawPolygonIcon from "jsx:./flaticon-uicons/draw-polygon.svg";
import DuplicateIcon from "jsx:./flaticon-uicons/duplicate.svg";
import EditIcon from "jsx:./flaticon-uicons/edit.svg";
import EyeIcon from "jsx:./flaticon-uicons/eye.svg";
import EyeCrossedIcon from "jsx:./flaticon-uicons/eye-crossed.svg";
import FileExportIcon from "jsx:./flaticon-uicons/file-export.svg";
import FilePdfIcon from "jsx:./flaticon-uicons/file-pdf.svg";
import FilterIcon from "jsx:./flaticon-uicons/filter.svg";
import FireExtinguisherIcon from "jsx:./flaticon-uicons/fire-extinguisher.svg";
import FireHydrantIcon from "jsx:./flaticon-uicons/fire-hydrant.svg";
import GaugeCircleBoltIcon from "jsx:./flaticon-uicons/gauge-circle-bolt.svg";
import GaugeCirclePlusIcon from "jsx:./flaticon-uicons/gauge-circle-plus.svg";
import GearsIcon from "jsx:./flaticon-uicons/gears.svg";
import GrateDropletIcon from "jsx:./flaticon-uicons/grate-droplet.svg";
import GroupArrowsRotateIcon from "jsx:./flaticon-uicons/group-arrows-rotate.svg";
import HighlighterLineIcon from "jsx:./flaticon-uicons/highlighter-line.svg";
import HomeIcon from "jsx:./flaticon-uicons/home.svg";
import HourglassEndIcon from "jsx:./flaticon-uicons/hourglass-end.svg";
import InterrogationIcon from "jsx:./flaticon-uicons/interrogation.svg";
import KeyIcon from "jsx:./flaticon-uicons/key.svg";
import KeyRegenerateIcon from "jsx:./flaticon-uicons/key_regenerate.svg";
import LandLayerLocationIcon from "jsx:./flaticon-uicons/land-layer-location.svg";
import LayersIcon from "jsx:./flaticon-uicons/layers.svg";
import LeverIndispoTempIcon from "jsx:./flaticon-uicons/lever_indispo_temp.svg";
import LicenseIcon from "jsx:./flaticon-uicons/license.svg";
import LightEmergencyOnIcon from "jsx:./flaticon-uicons/light-emergency-on.svg";
import ListIcon from "jsx:./flaticon-uicons/list.svg";
import LoadingIcon from "jsx:./flaticon-uicons/loading.svg";
import LockIcon from "jsx:./flaticon-uicons/lock.svg";
import MapIcon from "jsx:./flaticon-uicons/map.svg";
import MapPointIcon from "jsx:./flaticon-uicons/map-point.svg";
import MarkerIcon from "jsx:./flaticon-uicons/marker.svg";
import MatchFireIcon from "jsx:./flaticon-uicons/match-fire.svg";
import MemberListIcon from "jsx:./flaticon-uicons/member-list.svg";
import MenuBurgerIcon from "jsx:./flaticon-uicons/menu-burger.svg";
import MinusSmallIcon from "jsx:./flaticon-uicons/minus-small.svg";
import OverviewIcon from "jsx:./flaticon-uicons/overview.svg";
import PaletteIcon from "jsx:./flaticon-uicons/palette.svg";
import Percent100Icon from "jsx:./flaticon-uicons/percent-100.svg";
import PlusIcon from "jsx:./flaticon-uicons/plus.svg";
import PostalAddressIcon from "jsx:./flaticon-uicons/postal-address.svg";
import PrintIcon from "jsx:./flaticon-uicons/print.svg";
import RegistrationPaperIcon from "jsx:./flaticon-uicons/registration-paper.svg";
import RiskIcon from "jsx:./flaticon-uicons/risk.svg";
import RoadIcon from "jsx:./flaticon-uicons/road.svg";
import RotateLeftIcon from "jsx:./flaticon-uicons/rotate-left.svg";
import RouteIcon from "jsx:./flaticon-uicons/route.svg";
import RulerCombinedIcon from "jsx:./flaticon-uicons/ruler-combined.svg";
import SearchIcon from "jsx:./flaticon-uicons/search.svg";
import Square0Icon from "jsx:./flaticon-uicons/square-0.svg";
import SquareDashedIcon from "jsx:./flaticon-uicons/square-dashed.svg";
import SurveyXmarkIcon from "jsx:./flaticon-uicons/survey-xmark.svg";
import TableIcon from "jsx:./flaticon-uicons/table.svg";
import TimeFastIcon from "jsx:./flaticon-uicons/time-fast.svg";
import ToggleOffIcon from "jsx:./flaticon-uicons/toggle-off.svg";
import ToggleOnIcon from "jsx:./flaticon-uicons/toggle-on.svg";
import TransformationDesignIcon from "jsx:./flaticon-uicons/transformation-design.svg";
import TrashIcon from "jsx:./flaticon-uicons/trash.svg";
import TriangleIcon from "jsx:./flaticon-uicons/triangle.svg";
import TriangleWarningIcon from "jsx:./flaticon-uicons/triangle-warning.svg";
import UnlockIcon from "jsx:./flaticon-uicons/unlock.svg";
import UploadIcon from "jsx:./flaticon-uicons/upload.svg";
import UserAddIcon from "jsx:./flaticon-uicons/user-add.svg";
import UserGearIcon from "jsx:./flaticon-uicons/user-gear.svg";
import UserSlashIcon from "jsx:./flaticon-uicons/user-slash.svg";
import UsersIcon from "jsx:./flaticon-uicons/users.svg";
import ZoomInIcon from "jsx:./flaticon-uicons/zoom-in.svg";
import ZoomOutIcon from "jsx:./flaticon-uicons/zoom-out.svg";
import classNames from "classnames";
import * as styles from "./Icon.module.css";

interface IconProps {
  size?: string;
  className?: string;
}

function createIconComponent(
  SvgComponent: React.ComponentType<React.SVGProps<SVGSVGElement>>,
  style?: React.CSSProperties,
) {
  return function ({ size = "1em", className }: IconProps) {
    return (
      <span className={classNames(styles.icon, className)}>
        <SvgComponent style={{ height: size, width: size, ...style }} />
      </span>
    );
  };
}

export const IconEdit = createIconComponent(EditIcon);
export const IconClose = createIconComponent(CrossIcon);

export const IconEvent = createIconComponent(CalendarStarIcon);
export const IconMessage = createIconComponent(CommentAltIcon);
export const IconLocation = createIconComponent(MarkerIcon);
export const IconError = createIconComponent(CrossIcon);
export const IconLoading = createIconComponent(LoadingIcon);
export const IconCrise = createIconComponent(LightEmergencyOnIcon);
export const IconMerge = createIconComponent(CodeMergeIcon);
export const IconSearch = createIconComponent(SearchIcon);
export const IconExportCrise = createIconComponent(FileExportIcon);
export const IconFilter = createIconComponent(FilterIcon);
export const IconCamera = createIconComponent(CameraViewfinderIcon);
export const IconWarningCrise = createIconComponent(TriangleWarningIcon);
export const IconOverview = createIconComponent(OverviewIcon);
export const Toggle = ({
  toggled = false,
  ...props
}: Omit<IconProps, "icon"> & { toggled?: boolean }) =>
  createIconComponent(toggled ? ToggleOnIcon : ToggleOffIcon)({ ...props });
export const IconReturn = createIconComponent(ArrowLeftIcon);
export const IconMinus = createIconComponent(MinusSmallIcon);

export const IconDelete = createIconComponent(TrashIcon);
export const IconCreate = createIconComponent(AddIcon);
export const IconSee = createIconComponent(OverviewIcon);
export const IconPei = createIconComponent(FireHydrantIcon);
export const IconQuickAccess = createIconComponent(TimeFastIcon);

export const IconDocument = createIconComponent(DocumentIcon);
export const IconInfo = createIconComponent(InterrogationIcon);
export const IconAccuse = createIconComponent(CommentAltCheckIcon);

export const IconAireAspiration = createIconComponent(TriangleIcon);
export const IconEtude = createIconComponent(SurveyXmarkIcon);
export const IconPrescrit = createIconComponent(SurveyXmarkIcon);
export const IconRisque = createIconComponent(RiskIcon);
export const IconPermis = createIconComponent(LicenseIcon);
export const IconImport = createIconComponent(UploadIcon);
export const IconExport = createIconComponent(DownloadIcon);

export const IconLayers = createIconComponent(LayersIcon);

export const IconAnomalie = createIconComponent(BugIcon);
export const IconVisite = createIconComponent(GrateDropletIcon);
export const IconMoveObjet = createIconComponent(RouteIcon);
export const IconSelect = createIconComponent(SquareDashedIcon);
export const IconMoveCarte = createIconComponent(ArrowsIcon);
export const IconDistance = createIconComponent(RulerCombinedIcon);
export const IconSurface = createIconComponent(ChartAreaIcon);
export const IconZoomIn = createIconComponent(ZoomInIcon);
export const IconZoomOut = createIconComponent(ZoomOutIcon);
export const IconPeiPlusProche = createIconComponent(CareerPathIcon);
export const IconDebitSimultane = createIconComponent(GaugeCircleBoltIcon);
export const IconOeil = createIconComponent(EyeIcon);

export const IconUtilisateurs = createIconComponent(UsersIcon);

export const IconOldeb = createIconComponent(BioLeavesIcon);

export const IconProprietaire = createIconComponent(HomeIcon);
export const IconTransformGeometrie = createIconComponent(
  TransformationDesignIcon,
);

export const IconIndisponibiliteTemporaire =
  createIconComponent(HourglassEndIcon);

export const IconCarte = createIconComponent(MapIcon);

export const IconPoint = createIconComponent(DotCircleIcon);

export const IconLine = createIconComponent(HighlighterLineIcon);

export const IconPolygon = createIconComponent(DrawPolygonIcon);

export const IconStyle = createIconComponent(PaletteIcon);

export const IconPrint = createIconComponent(PrintIcon);

export const IconRotate = createIconComponent(GroupArrowsRotateIcon);
export const IconRotateLeft = createIconComponent(RotateLeftIcon);

export const IconLeverIndisponibiliteTemporaire =
  createIconComponent(LeverIndispoTempIcon);

export const IconCriseRapportPersonnalise = createIconComponent(MemberListIcon);
export const IconList = createIconComponent(ListIcon);
export const IconDuplicate = createIconComponent(DuplicateIcon);

export const IconTournee = createIconComponent(RoadIcon);
export const IconSortList = createIconComponent(AppsSortIcon);
export const IconDragNDrop = createIconComponent(MenuBurgerIcon);
export const IconDesaffecter = createIconComponent(UserSlashIcon);
export const IconZeroPourcent = createIconComponent(Square0Icon);
export const IconCentPourcent = createIconComponent(Percent100Icon);

export const IconLock = createIconComponent(LockIcon);
export const IconUnlock = createIconComponent(UnlockIcon);

export const IconAddContact = createIconComponent(UserAddIcon);
export const IconGererContact = createIconComponent(UserGearIcon);
export const IconPlus = createIconComponent(PlusIcon);
export const IconDFCI = createIconComponent(FireExtinguisherIcon);
export const IconAdd = createIconComponent(AddIcon);

export const IconNextPage = createIconComponent(AngleCircleRightIcon);
export const IconPreviousPage = createIconComponent(AngleCircleLeftIcon);
export const IconQuestionMark = createIconComponent(InterrogationIcon);

export const IconValidation = createIconComponent(RegistrationPaperIcon);

export const IconPieChartComponent = createIconComponent(ChartPieAltIcon);
export const IconGaugeComponent = createIconComponent(GaugeCirclePlusIcon);
export const IconHorizontalChartComponent = createIconComponent(
  ChartSimpleHorizontalIcon,
);
export const IconTableComponent = createIconComponent(TableIcon);
export const IconCounterComponent = createIconComponent(ConciergeBellIcon);
export const IconMapComponent = createIconComponent(LandLayerLocationIcon);
export const IconArrowUp = createIconComponent(ArrowCircleUpIcon);

export const IconSignalement = createIconComponent(PostalAddressIcon);

export const IconRCCI = createIconComponent(MatchFireIcon);

export const IconParametre = createIconComponent(GearsIcon);
export const IconHide = createIconComponent(EyeCrossedIcon);

export const IconWarning = createIconComponent(TriangleWarningIcon);
export const IconCursorAdd = createIconComponent(CursorPlusIcon);
export const IconCreateApi = createIconComponent(KeyIcon);
export const IconRegenereApi = createIconComponent(KeyRegenerateIcon);

export const IconeGenereCarteTournee = createIconComponent(MapPointIcon);

export const IconPdf = createIconComponent(FilePdfIcon);
